/**
 * Cheap pending-highlight sync for smart-rendered rows.
 * Mass `refreshTask` freezes large cascades; scrolling would eventually re-apply
 * `grid_row_class`, but visible rows need an immediate CSS pass.
 */
export function syncVisiblePendingRowClasses(
  root: ParentNode,
  pendingIds: Set<string>,
): void {
  root
    .querySelectorAll('.gantt_row[data-task-id], .gantt_task_row[data-task-id]')
    .forEach((node) => {
      const el = node as HTMLElement;
      const id = el.getAttribute('data-task-id');
      if (id == null) return;
      el.classList.toggle('gantt-row-pending-change', pendingIds.has(id));
    });

  if (pendingIds.size === 0) {
    root.querySelectorAll('.gantt-cell-pending-change').forEach((el) => {
      el.classList.remove('gantt-cell-pending-change');
    });
    root.querySelectorAll('.is-pending-change').forEach((el) => {
      el.classList.remove('is-pending-change');
    });
  }
}
